export default __webpack_public_path__ + "static/media/top-section-mob.e5c1a8d5.jpg";